import { createContext } from '@lyearn/core/utils/context';
import { UseDraggableListReturnType } from '@/modules/corporate/components/DraggableList/hooks/useDraggableList/types';

import { DatabaseFormEditorProps } from '../../types';

interface DatabaseFormEditorContextValue extends Omit<DatabaseFormEditorProps, 'fields'> {
  draggingItemRef: UseDraggableListReturnType['draggingItemRef'];
  onDrop: UseDraggableListReturnType['onDrop'];
  getFieldAttributes: (fieldId: string) => { index: number; descriptionEnabled: boolean };
}

export const [DatabaseFormEditorProvider, useDatabaseFormEditor] =
  createContext<DatabaseFormEditorContextValue>('DatabaseFormEditor');
